function Divider() {
  return <hr className='divider full-width' />;
}

export default Divider;
